import React from 'react'
import { UserPoll } from '../types'
import './UserPollSection.css'

interface UserPollSectionProps {
  userPolls: UserPoll[]
  pollAnswers: Record<number, number>
  isLoadingPolls: boolean
  showPollError: boolean
  onPollAnswerChange: (pollId: number, answerId: number) => void
}

const UserPollSection: React.FC<UserPollSectionProps> = ({
  userPolls,
  pollAnswers,
  isLoadingPolls,
  showPollError,
  onPollAnswerChange,
}) => {
  if (isLoadingPolls || userPolls.length === 0) {
    return null
  }

  return (
    <div className="user-polls-section">
      <h3>Contanos un poco más sobre vos</h3>

      {userPolls.map((poll) => {
        const isAnswered = pollAnswers[poll.id] && pollAnswers[poll.id] > 0
        return (
          <div
            key={poll.id}
            className={`poll-question ${
              isAnswered ? 'answered' : 'unanswered'
            }`}
          >
            <p className="poll-question-text">
              {poll.question}
              {!isAnswered && <span className="required-indicator"> *</span>}
            </p>
            <select
              className={`poll-answer-select ${
                isAnswered ? 'answered' : 'unanswered'
              }`}
              value={pollAnswers[poll.id] || ''}
              onChange={(e) =>
                onPollAnswerChange(poll.id, Number(e.target.value))
              }
            >
              <option value="">Selecciona una respuesta</option>
              {poll.detail.map((answer) => (
                <option key={answer.id} value={answer.id}>
                  {answer.answer}
                </option>
              ))}
            </select>
          </div>
        )
      })}

      <p className={`poll-info ${showPollError ? 'poll-error' : ''}`}>
        <span className="required-indicator">*</span> Todas las preguntas son
        obligatorias
      </p>
    </div>
  )
}

export default UserPollSection
